"use client"

/**
 * Enables PageHeader → utility bar action relocation on Back / Breadcrumb chrome.
 */

import * as React from "react"

import { useSetPageHeaderScrollRelocateEnabled } from "@exxatdesignux/ui/components/shell/page-header-scroll-actions"
import { useUtilityBarPageChrome } from "@/components/utility-bar-page-chrome"

export function PageHeaderScrollActionsBridge() {
  const chrome = useUtilityBarPageChrome()
  const setRelocate = useSetPageHeaderScrollRelocateEnabled()

  React.useLayoutEffect(() => {
    const enabled = chrome.mode === "back" || chrome.mode === "breadcrumb"
    setRelocate(enabled)
    return () => setRelocate(false)
  }, [chrome.mode, setRelocate])

  return null
}
